"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("../utils");
var styles = {
  "popover-wrapper": "LifecycleState__popover-wrapper__1Ff8c",
  "popoverWrapper": "LifecycleState__popover-wrapper__1Ff8c",
  "container": "LifecycleState__container__3-Faz",
  "published": "LifecycleState__published__2-Z9Z",
  "published-edit": "LifecycleState__published-edit__rjH3d",
  "publishedEdit": "LifecycleState__published-edit__rjH3d",
  "development": "LifecycleState__development__2vPq_",
  "development-edit": "LifecycleState__development-edit__VWk6h",
  "developmentEdit": "LifecycleState__development-edit__VWk6h",
  "deprecated": "LifecycleState__deprecated__35P3a",
  "deprecated-edit": "LifecycleState__deprecated-edit__22zI4",
  "deprecatedEdit": "LifecycleState__deprecated-edit__22zI4",
  "lifecycle-state": "LifecycleState__lifecycle-state__2sdPy",
  "lifecycleState": "LifecycleState__lifecycle-state__2sdPy",
  "icon": "LifecycleState__icon__1sKrw",
  "dropdown-icon": "LifecycleState__dropdown-icon__2l1Yy",
  "dropdownIcon": "LifecycleState__dropdown-icon__2l1Yy",
  "menu-header": "LifecycleState__menu-header__3RQEW",
  "menuHeader": "LifecycleState__menu-header__3RQEW",
  "menu-title": "LifecycleState__menu-title__3Llp_",
  "menuTitle": "LifecycleState__menu-title__3Llp_",
  "menu-item-label": "LifecycleState__menu-item-label__2Bi-z",
  "menuItemLabel": "LifecycleState__menu-item-label__2Bi-z",
  "warning-icon": "LifecycleState__warning-icon__1JA0J",
  "warningIcon": "LifecycleState__warning-icon__1JA0J",
  "menu-icon": "LifecycleState__menu-icon__1no_1",
  "menuIcon": "LifecycleState__menu-icon__1no_1",
  "menu": "LifecycleState__menu__2nbH-",
  "menu-options": "LifecycleState__menu-options__3y1qG",
  "menuOptions": "LifecycleState__menu-options__3y1qG",
  "menu-item": "LifecycleState__menu-item__3jhwF",
  "menuItem": "LifecycleState__menu-item__3jhwF",
  "spinner": "LifecycleState__spinner__2VjIH",
  "loader": "LifecycleState__loader__2vter",
  "light-theme": "LifecycleState__light-theme__3IReQ",
  "lightTheme": "LifecycleState__light-theme__3IReQ"
}; 
require('../LifecycleState.css');
var LifecycleStatePill = function LifecycleStatePill(_ref) {
  var status = _ref.status,
    _ref$lightTheme = _ref.lightTheme,
    lightTheme = _ref$lightTheme === void 0 ? false : _ref$lightTheme;
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "pill-lifecycle-popover-wrapper",
    className: (0, _classnames.default)(styles.popoverWrapper, (0, _defineProperty2.default)({}, styles.lightTheme, lightTheme))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(styles.container, styles[status]),
    "data-test-id": "pill-lifecycle-state"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: styles.lifecycleState,
    "data-test-id": "pill-lifecycle-state-label"
  }, (0, _utils.getStatusLabel)(status))));
};
var _default = exports.default = LifecycleStatePill;
//# sourceMappingURL=LifecycleStatePill.js.map